module.exports = __webpack_public_path__ + "img/thumb-appelcake-met-banaan-en-yoghurt.a0e6e7b8.jpg";